import { SVGProps } from 'react'

export const Archive = ({
  size = 24,
  className,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 3H5.75H10.5H10.8107L11.0303 3.21967L12.8107 5H18.25H19V5.75V9H20.255H21.005V9.75V21.25V22H20.255H3.75H3V21.25V9.75V9H3.75H5V3.75V3ZM17.5 6.5V9H6.5V4.5H10.1893L11.9697 6.28033L12.1893 6.5H12.5H17.5ZM4.5 10.5V20.5H19.505V10.5H4.5ZM7.75 13H7V14.5H7.75H11.75H12.5V13H11.75H7.75Z"
      fill="currentColor"
    />
  </svg>
)
